import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '@shared/utils/util';
import { SocialCausesService } from '@shared/services/social-causes.service';

@Component({
  selector: 'app-more-details',
  templateUrl: './more-details.component.html',
  styleUrls: ['./more-details.component.scss'],
})
export class MoreDetailsComponent  implements OnInit {
  @Input() me: any;
  constructor(
    private translate: TranslateService,
    private socialCausesService: SocialCausesService
  ) {}

  ngOnInit() {}

  lookingForOptions() {
    if (this.me.lookingFor != null) {
      let optionsChosen: any = [];

      this.me.lookingFor.forEach((option: string | string[]) => {
        optionsChosen.push(this.translate.instant(option));
      });

      return optionsChosen.join(", ");
    } else {
      return "";
    }
  }

  setHeight() {
    let heightValueFoot: number;
    let heightValueInch: number;

    heightValueFoot = this.me.height * 0.0328084 | 0;  //cm -> feet
    heightValueInch = ((this.me.height * 0.0328084) - heightValueFoot) * 12 | 0; //feet -> inches

    return ((this.me.height / 100) + " m / " + heightValueFoot + "'" + heightValueInch);
  }

  getSocialCauseDisplayText(causeId: string): string {
    return this.socialCausesService.getSocialCauseDisplayText(causeId);
  }

}


